import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"none\" id=\"arrow-left\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 10.3999H4.99996V9.59988H16V10.3999Z\" fill=\"currentColor\" />\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.53514 6.53516L4.07031 9.99998L7.53514 13.4648L8.10082 12.8991L5.20168 9.99998L8.10082 7.10084L7.53514 6.53516Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol